import { Immutable } from "immer";
import React from "react";

import type { FinePrintBarBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";

type Props = Immutable<{
    value: Value;
}>;

/**
 * React port of the pillows-specific ``FinePrintBarBlock`` PDP section.
 * DOM mirrors the legacy Django template
 * ``cms/components/fine_print_bar.html`` exactly — a list of sections,
 * each with a plain CharBlock ``title`` and a RichText ``copy`` body.
 */
export const FinePrintBarBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    const sections = v.sections ?? [];
    return (
        <div className="l-full-width fine-print-bar">
            <div className="l-capped-width">
                <ul className="fine-print-bar__container">
                    {sections.map((section, i) => (
                        <li key={i} className="fine-print-bar__inner">
                            <h3 className="fine-print-bar__title">
                                {section.title ?? ""}
                            </h3>
                            <div className="fine-print-bar__copy">
                                <RichTextBlock value={section.copy ?? ""} />
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
